import React, { HTMLAttributes } from "react";
import classNames from "classnames";
import LsLoading, { useLsLoadingWrapper } from "Components/LsLoading";

export type ModuleSize = "lg" | "md" | "sm";

export interface ModuleProps extends HTMLAttributes<HTMLDivElement> {
   tag?: string,
   size?: ModuleSize,
   fluid?: boolean,
   loading?: boolean,
   withPager?: boolean,
}

const Module: React.FC<ModuleProps> = ({ children, tag, size, className, fluid, loading, withPager, ...divProps }) => {
   const wrapperClass = useLsLoadingWrapper(loading);
   return React.createElement(tag || "div", {
      ...divProps,
      className: classNames("management-module", className, wrapperClass, {
         [`management-module-${size}`]: !!size,
         "management-module--fluid": fluid,
         "management-module--with-pager": withPager,
      }),
   },
      loading
         ? (<LsLoading isLoading={true} />)
         : children);
}

export default Module



